import { render, staticRenderFns } from "./ZoList.vue?vue&type=template&id=71f94825&scoped=true&"
import script from "./ZoList.vue?vue&type=script&lang=js&"
export * from "./ZoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f94825",
  null
  
)

export default component.exports